import React from 'react';
import { useSelector } from 'react-redux';

import selectors from 'state/selectors';
import utils from 'utils';

import Modal from 'components/Modal';

const ForceBlockConfirmationModal = () => {
  const t = utils.intl.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);

  return (
    <>
      <Modal.Header title={modalProps.title ?? t('force_block_confirmation')} subtitle={modalProps.subtitle} />
      <Modal.Footer
        withConfirmButton={modalProps.withConfirmButton ?? true}
        confirmText={modalProps.confirmText ?? t('force_block')}
        confirmAction={modalProps.func}
        dontCloseOnConfirm={modalProps.dontCloseOnConfirm}
        closeButtonText={modalProps.backText ?? t('annulla')}
      />
    </>
  );
};

export default ForceBlockConfirmationModal;
